import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';
// Types
import { Winner } from 'types/lottery/winner';

export const thirdWinnersState = atom<Winner[]>({
  key: ATOM_KEYS.THIRD_WINNERS_STATE,
  default: [],
});
